@if (error) {
  <div>
    {{ error }}
  </div>
}
<form [formGroup]="form" (submit)="onSubmit()">
  <div class="input-group">
    <mat-form-field>
      <mat-select
        placeholder="Tenant Name"
        formControlName="tenantId"
        [disabled]="_tenantPreviouslySet"
        [matTooltip]="
          _tenantPreviouslySet ? ('tenants.cannotOverwrite' | translate) : ''
        "
        >
        <mat-option [value]="null"> None </mat-option>
        @for (item of tenants$ | async | keyvalue; track item) {
          <mat-option
            [value]="item.key"
            >
            {{ item.value.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="input-group">
    <mat-form-field>
      <input
        matInput
        type="text"
        class="input-wide"
        placeholder="Organisation Name"
        formControlName="name"
        />
    </mat-form-field>
  </div>
  <div class="input-group">
    <mat-form-field>
      <input
        matInput
        type="tel"
        class="input-wide"
        placeholder="Contact Phone Number"
        formControlName="contactNumber"
        />
    </mat-form-field>
  </div>
  <div formGroupName="address">
    <div class="input-group">
      <mat-form-field>
        <input
          matInput
          type="text"
          class="input-wide"
          placeholder="Address Line 1"
          formControlName="address1"
          />
      </mat-form-field>
    </div>
    <div class="input-group">
      <mat-form-field>
        <input
          matInput
          type="text"
          class="input-wide"
          placeholder="Address Line 2"
          formControlName="address2"
          />
      </mat-form-field>
    </div>
    <div class="input-group">
      <mat-form-field>
        <input
          matInput
          type="text"
          placeholder="Town / Suburb"
          formControlName="town"
          />
      </mat-form-field>
    </div>
    <div class="input-group">
      <mat-form-field>
        <input
          matInput
          type="text"
          placeholder="State"
          formControlName="state"
          />
      </mat-form-field>
    </div>
    <div class="input-group">
      <mat-form-field>
        <input
          matInput
          type="text"
          class="input-narrow"
          placeholder="Postcode"
          formControlName="postcode"
          />
      </mat-form-field>
    </div>
    <div class="input-group">
      <mat-form-field>
        <input
          matInput
          type="text"
          class="input-wide"
          placeholder="Country"
          formControlName="country"
          />
      </mat-form-field>
    </div>
  </div>
  <div class="input-group">
    <mat-form-field>
      <input
        matInput
        type="number"
        class="input-wide"
        placeholder="Capacity"
        formControlName="capacity"
        min="0"
        ng-pattern="^[0-9]"
        />
    </mat-form-field>
  </div>
  <div class="input-group">
    <mat-slide-toggle formControlName="enabled">Enabled</mat-slide-toggle>
    @if (form.get('enabled').value === false) {
      <p>
        This site is disabled. Users will not be able to perform any actions.
      </p>
    }
  </div>
  <div class="button-group">
    @if (!_readOnly) {
      <button
        [disabled]="loading"
        role="button"
        color="primary"
        (click)="onSubmit()"
        ca-raised-button
        >
        {{ mode === FormMode.CREATE ? "Create Site" : "Save" }}
      </button>
    }
  </div>
</form>
